<template>
  <iframe :src="params.src" @load="hijacklinks()"/>
</template>

<script>
export default {
  props: ["params"],
  mounted() {
    document.addEventListener("load", () => {
      console.log("load");
      const links = document.getElementsByTagName("a");

      for (const l in links) {
        l.writeAttribute("target", "_parent");
      }
    });
  },
  methods: {
    hijacklinks() {
      const as = document.getElementsByTagName('iframe')[0].getElementsByTagName("a");
      for (const a of as) {
        a.setAttribute("target", "_parent");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
iframe {
  width: 100%;
  height: calc(100vh - 152px);
  border: none;
}
</style>
